import { testimonials } from '@/mocks/testimonials';

export default function BrandIntro() {
  return (
    <section>
      <div className="text-center mb-12">
        <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">品牌故事</span>
        <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 mb-4">
          关于一起草每日大赛
        </h1>
        <p className="text-foreground-600 max-w-3xl mx-auto leading-relaxed">
          一起草每日大赛成立于2023年，是国内首个专注于草类竞技的每日在线赛事平台。
          我们致力于为全国草类竞技爱好者打造一个公平、专业、有趣的竞技舞台。
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mb-16">
        <div className="relative h-80 md:h-96 rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Professional%20grass%20sports%20arena%20with%20athletes%20training%20on%20green%20field%20at%20sunrise%2C%20modern%20sports%20facility%2C%20clean%20minimal%20architecture%2C%20inspirational%20atmosphere%2C%20soft%20morning%20light%2C%20editorial%20photography&width=800&height=600&seq=about-brand-01&orientation=landscape"
            alt="一起草品牌形象"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="flex flex-col justify-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">我们的使命</h2>
          <p className="text-foreground-600 leading-relaxed mb-4">
            在快节奏的现代生活中，越来越多人渴望回归自然、享受户外运动的乐趣。一起草应运而生，我们相信草地不仅是运动场，更是连接人与自然、人与人之间的纽带。
          </p>
          <p className="text-foreground-600 leading-relaxed mb-4">
            我们的平台每日举办多场不同类型的草类竞技赛事，涵盖草地竞技、草园赛道、绿地挑战等多个项目。无论你是专业选手还是休闲玩家，都能在这里找到适合自己的挑战。
          </p>
          <p className="text-foreground-600 leading-relaxed">
            成立三年来，一起草已累计举办超过<strong className="text-primary-600">10,000场</strong>赛事，服务超过<strong className="text-primary-600">50,000名</strong>注册选手，覆盖全国<strong className="text-primary-600">32个</strong>主要城市。我们用数据证明：草类竞技，大有可为。
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
        {[
          { value: '10,000+', label: '累计赛事' },
          { value: '50,000+', label: '注册选手' },
          { value: '32', label: '覆盖城市' },
          { value: '98.5%', label: '选手满意度' },
        ].map((stat) => (
          <div key={stat.label} className="bg-primary-50 rounded-xl p-6 text-center">
            <div className="text-2xl md:text-3xl font-display font-bold text-primary-600 mb-1">{stat.value}</div>
            <div className="text-sm text-foreground-600">{stat.label}</div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {[
          { icon: 'ri-shield-check-line', title: '公平竞技', desc: '采用国际标准评分体系，确保每场比赛公平公正。AI辅助裁判系统杜绝人为误差。' },
          { icon: 'ri-trophy-line', title: '每日赛事', desc: '每天都有全新挑战等你参与。赛事类型丰富多样，总有一款适合你。' },
          { icon: 'ri-bar-chart-grouped-line', title: '实时排名', desc: '数据驱动的排名系统，每周更新。清晰追踪你的竞技成长轨迹。' },
          { icon: 'ri-gift-line', title: '丰厚奖励', desc: '高额奖金池和丰富实物奖品。每一份努力都有回报，每一位选手都值得嘉奖。' },
          { icon: 'ri-team-line', title: '社群联动', desc: '全国范围内的选手交流社群。分享经验、组队参赛，竞技之路不再孤单。' },
          { icon: 'ri-health-book-line', title: '安全保障', desc: '专业医疗团队全程保障，完善的安全规范。让你安心享受竞技乐趣。' },
        ].map((item) => (
          <div key={item.title} className="bg-background-100 rounded-xl p-6">
            <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg mb-4">
              <i className={`${item.icon} text-primary-600 text-lg`}></i>
            </div>
            <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">{item.title}</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}